import { t } from '@/utils/i18n'
import styles from './ProductNotFound.module.less'
import { useNavigate } from 'react-router-dom'
import { routesMap, common } from '@/utils'
import productNotFoundSvg from '@/assets/img/product_not_found.svg'

const { hasHomeModule } = common

function ProductNotFound() {
  const navigate = useNavigate()

  // 回到首页
  async function handleEnterStore() {
    const homeModule = await hasHomeModule();
    if (homeModule) {
      navigate(routesMap.App)
    } else {
      navigate(routesMap.Products)
    }
  }

  return (
    <div className={styles['product-not-found']}>
      <div className={styles['bd']}>
        <img className={styles['product-img']} src={productNotFoundSvg} />
        <p className={styles['grey']}>{t('商品找不到了…')}</p>
        <div className={styles['button-block']}>
          <button
            className={styles['enter-store']}
            onClick={handleEnterStore}
          >
            {t('进入店铺')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ProductNotFound
